export default "__VITE_ASSET__BaWUCpLo__"